import React from 'react';
import Rimg from './Rimg.jsx';
import Slider from './Slider.jsx';
import ProductContext from './ProductContext.jsx';
import SVG from './SVG.jsx';

export default class ProductMobileGallery extends React.PureComponent {
  constructor(props) {
    super();
    this.sliderRef = React.createRef();
    this.sliderNavRef = React.createRef();
    this.state = {currentIndex: 0};

    this.mobileGallerySlider = this.mobileGallerySlider.bind(this);
    this.calculatePivot = this.calculatePivot.bind(this);
    this.inversePivot = this.inversePivot.bind(this);
    this.zoomLabel = this.zoomLabel.bind(this);
  }

  inversePivot(i) {
    return (i + this.props.thumbPivot) % this.props.media.length;
  }

  calculatePivot(i) {
    return (this.props.media.length + i - this.props.thumbPivot) % this.props.media.length;
  }

  mobileGallerySlider() {
    const options = {
      prevNextButtons: false,
      pageDots: false
    };
    if (this.props.tags.includes('show-previews')) {
      return <Slider options={options} ref={this.sliderNavRef} className="mobile-product-images-slider-nav">
        {this.props.media.map((currentMedia, i) => {
          const currentIndex = this.calculatePivot(i);
          const media = this.props.media[currentIndex];
          let cName = 'mobile-product-image-nav wrap';
          let clickHandler = (e) => {this.sliderRef.current.flickity.select(currentIndex)};
          if (currentIndex === this.state.currentIndex) {
            cName += ' active';
          }
          let mediaIcon = null;
          if (media.media_type === 'model') {
            cName += ' model-thumb';
            mediaIcon = <span className="play-media">
              <SVG icon="3d" />
            </span>
          }
          if (media.media_type === 'video') {
            clickHandler = this.props._openProductVideoModal;
            cName += ' video-thumb';
            mediaIcon = <span className="play-media">
              <SVG icon="video" />
            </span>
          }
          if (media.alt && media.alt.includes('mp4')) {
            cName += ' video-thumb';
            mediaIcon = <span className="play-media">
              <SVG icon="video" />
            </span>
          }
          return <div className={cName} key={i}>
            <Rimg src={media.preview_image.src} loading="lazy" width={media.preview_image.width} height={media.preview_image.height} onClick={clickHandler} alt={media.alt || this.props.productName} />
            {mediaIcon}
            <span className="overlay"></span>
          </div>
        })}
      </Slider>
    }
    return (null);
  }

  zoomLabel() {
    if (this.props.media.length < 1) {
      return (null);
    }
    const currentMedia = this.props.media[this.state.currentIndex]
    if (currentMedia.media_type === 'video' || currentMedia.alt && currentMedia.alt.includes('.mp4')) {
      return (null)
    }
    if (currentMedia.media_type === 'model') {
      return <span className="model-zoom-trigger">
        <SVG icon="3d" />
        <i>{this.context.i18n.viewModel}</i>
      </span>
    }
    return <span className="image-zoom-trigger">
      <SVG icon="search" />
      {this.context.i18n.mobileZoomImage && <i>{this.context.i18n.mobileZoomImage}</i>}
    </span>
  }

  render() {
    const flickityOptions = {
      wrapAround: true,
      pageDots: !this.props.tags.includes('show-previews'),
      on: {
        ready: () => {
          if (!this.props.tags.includes('show-previews')) {
            if (this.sliderRef.current) {
              const pageDots = this.sliderRef.current.querySelectorAll('.flickity-page-dots .dot');
              this.props.media.forEach((media, i) => {
                if (media.media_type === 'model') {
                  pageDots[i].setAttribute('data-model', 'true');
                } else if (media.alt && ~media.alt.indexOf('mp4')) {
                  pageDots[i].setAttribute('data-video', 'true');
                }
              })
            }
          }
        },
        select: (i) => {
          const slide = this.sliderRef.current.flickity.selectedElement;
          window.dataLayer.push({ 'event': 'Viewed Product Image', 'image_id': (i + 1) });
          window.heap && window.heap.track('ProductImageView', { imageIndex: (i + 1), imageSrc: this.props.media[i].src, handle: this.props.handle });
          if (slide.classList.contains('mobile-product-video')) {
            window.dataLayer.push({ 'event': 'Played Video - Thumbnail' });
          }
        },
        change: (i) => {
          this.setState({currentIndex: i});
          if (this.sliderNavRef.current) {
            const currentIndex = this.inversePivot(i);
            this.sliderNavRef.current.flickity.select(currentIndex);
          }
        }
      }
    }

    return <div className="showcase product-images mobile-slider-enabled">
      <Slider options={flickityOptions} className="mobile-product-image-slider" ref={this.sliderRef}>
        {this.props.media.map((media, i) => {
          if (media.media_type === 'video') {
            return (null)
            /* return <div className="mobile-product-image mobile-product-video" key={i}>
              {this.state.currentIndex === i && <video className='product-video current-image' autoPlay loop playsInline muted={true} controls={false} height={media.height} width={media.width}>
                {media.sources.slice(0).reverse().map((source, j) =>
                  <source type={source.mime_type} height={source.height} width={source.width} src={source.url} key={j} />
                )}
              </video>}
            </div> */
          }
          if (media.media_type === 'model') {
            return <div className="mobile-product-image" key={i}>
              <Rimg src={media.preview_image.src} loading="lazy" width={media.preview_image.width} height={media.preview_image.height} onClick={(e) => {this.props._openImageZoom(media.id, e.currentTarget)}} alt={media.alt || this.props.productName} />
            </div>
          }
          if (media.alt && media.alt.includes('.mp4')) {
            return <div className="mobile-product-image mobile-product-video" key={i}>
              {this.state.currentIndex === i && <video src={`${this.context.productSettings.cdnUrl}${media.alt}`} autoPlay loop playsInline muted={true} controls={false} height={media.height} width={media.width} />}
            </div>
          }
          return <div className="mobile-product-image" key={i}>
            <Rimg src={media.src} loading="lazy" width={media.width} height={media.height} onClick={(e) => {this.props._openImageZoom(media.id, e.currentTarget)}} alt={media.alt || this.props.productName} />
          </div>
        })}
      </Slider>
      <this.zoomLabel />
      <this.mobileGallerySlider />
    </div>
  }
}

ProductMobileGallery.contextType = ProductContext;